import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 100%;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 20px;
  width: 580px;
  height: 230px;
  padding: 30px 50px;
  box-shadow: 0 2px 15px -5px #000;
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const CardBody = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: .3rem 0 0 0 !important;
`